import styled from 'styled-components'
import { space, SpaceProps } from 'styled-system'

export type CardBodyProps = SpaceProps

const CardBody = styled.div<CardBodyProps>`
  background-color: #fff;
  /* border-radius: 20px */
  /* border-radius: 30px; */
  /* margin-top: 20px; */
  ${space}
`

CardBody.defaultProps = {
  p: '24px',
}

export default CardBody
